import React from 'react';

interface BrandMarkProps {
  variant?: 'horizontal' | 'vertical' | 'icon';
  className?: string;
}

const BrandMark: React.FC<BrandMarkProps> = ({ variant = 'horizontal', className = '' }) => {
  if (variant === 'icon') {
    return (
      <img
        src="/brand/isotipo.png"
        alt="Tickets Exchange"
        className={`rounded-full object-contain bg-white border-2 border-gold-500 p-0.5 ${className}`}
      />
    );
  }

  if (variant === 'vertical') {
    return (
      <img
        src="/brand/logo-vertical.png"
        alt="Tickets Exchange"
        className={`object-contain ${className}`}
      />
    );
  }

  return (
    <img
      src="/brand/logo-horizontal.png"
      alt="Tickets Exchange"
      className={`object-contain ${className}`}
    />
  );
};

export default BrandMark;
